type PageType = 'article' | 'frontpage' | 'section' | 'topic' | 'search' | 'error';
type WallType = 'open' | 'paywall';

export function mapWallType (legacy: string | undefined | null): WallType | undefined {
  if (!legacy) { return undefined; }
  if (legacy === 'paywall') { return 'paywall'; }
  return 'open';
}

const LEGACY_PAGE_TYPE_MAP: Record<string, PageType> = {
  sectionpage: 'section',
  categorypage: 'section',
  latestpage: 'section',
  staticpage: 'section',
  tagpage: 'topic',
  searchpage: 'search'
};

export function mapPageType (legacy: string | undefined | null): PageType | undefined {
  if (!legacy) { return undefined; }
  if (legacy in LEGACY_PAGE_TYPE_MAP) { return LEGACY_PAGE_TYPE_MAP[legacy]; }
  return legacy as PageType;
}

export function toMilliseconds (timestamp: number | undefined | null): number | undefined {
  if (timestamp === null || timestamp === undefined || Number.isNaN(timestamp)) {
    return undefined;
  }
  return timestamp < 1e12 ? timestamp * 1000 : timestamp;
}
